import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { StackLayout, UtilityText } from '@leagueplatform/genesis-core';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { SwitchIndicator } from '@leagueplatform/web-common-components';
import { useChallengesAnalytics } from '#hooks/use-challenges-analytics.hook.tsx';
import {
  CLP_DETAIL,
  CLP_SCREEN_NAMES,
} from '#constants/analytics.constants.tsx';
import { usePatchPrivacyConfig } from '#hooks/use-patch-privacy-config.hook.ts';

const { CHALLENGES_PRIVACY_SETTINGS } = CLP_SCREEN_NAMES;
const { HIDE_ACTIVITY, SHOW_ACTIVITY } = CLP_DETAIL;
type SettingsToggleProps = {
  showFeedItems: boolean;
};
export const SettingsToggle = ({ showFeedItems }: SettingsToggleProps) => {
  const { formatMessage } = useIntl();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const patchPrivacyMutation = usePatchPrivacyConfig();

  return (
    <StackLayout
      orientation={{
        '@initial': 'vertical',
        '@laptop': 'horizontal',
        '@desktop': 'horizontal',
      }}
      horizontalAlignment="spaceBetween"
      verticalAlignment="center"
      spacing="$oneAndHalf"
    >
      <UtilityText>
        {formatMessage({ id: 'CHALLENGE_ACTIVITY_DETAIL' })}
      </UtilityText>
      <StackLayout
        orientation="horizontal"
        verticalAlignment="center"
        spacing="$oneAndHalf"
        horizontalAlignment={{
          '@initial': 'start',
          '@laptop': 'end',
          '@desktop': 'end',
        }}
      >
        <UtilityText
          as="label"
          emphasis="emphasized"
          htmlFor="show-activity-switch"
          css={{
            color: '$interactiveActionPrimary',
          }}
        >
          {formatMessage({ id: 'SHOW_MY_ACTIVITY' })}
        </UtilityText>
        <SwitchIndicator
          id="show-activity-switch"
          loading={patchPrivacyMutation.isLoading}
          onClick={() => {
            const toggledShowFeedItems = !showFeedItems;
            patchPrivacyMutation.mutate({
              showFeedItems: toggledShowFeedItems,
            });
            trackChallengesAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
              screen_name: CHALLENGES_PRIVACY_SETTINGS,
              detail: toggledShowFeedItems ? SHOW_ACTIVITY : HIDE_ACTIVITY,
            });
          }}
          checked={showFeedItems}
        />
      </StackLayout>
    </StackLayout>
  );
};
